module.exports = __webpack_public_path__ + "img/phone.6ae674ce.svg";